/*

  m a t c h i ng  i n t e r f a c e
  Matching Interface

  :description:
  A class that can load matches from the cloud.

*/

//
//  :code:
import { loadJSON, postJSON } from '../js/requests'
import { talk } from '../js/talk'

//
//  :statics:
//  Variables and static declarations.
export const EYEKANDY_MATCHING_INTERFACE = 'EyekandyMatchingInterface'

//
//  :classes:
export class EyekandyMatchingInterface {
  constructor (options) {
    if (typeof options === 'undefined') {
      options = {}
    }
    //
    //  :core:
    //  Core settings and values.
    this.name = 'eyekandy-matching-interface'
    this.version = 'v4.0.0'
    this.group = '[EYEKANDY-MATCHING-INTERFACE]'

    //
    //  :runtime:
    this.environment = options.environment || 'dev'
    this.urls = {
      dev: `https://d2hx4jztfjw5ul.cloudfront.net/resolve/`,
      prod: `https://d2hx4jztfjw5ul.cloudfront.net/resolve/`
    }

    //
    //  :echo:
    //  Write out into the console that the instance was created.
    talk([this.group, `created a new instance @ '${this.version}'`])
  }

  //
  //  :api:
  //  Exposed API functions for callers.
  //  -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -

  async resolveMatches (
    distributor,
    services,
    language,
    skuOrSKUs,
    eanOrEans,
    mpnOrMPNs,
    upcOrUPCs,
    urlOrURLs
  ) {
    //
    //  :step 1:
    //  Assemble our URL.
    const baseUrl = this.urls[this.environment]
    const mapping = {
      distributor: distributor,
      services: services,
      language: language,
      skus: skuOrSKUs,
      eans: eanOrEans,
      mpns: mpnOrMPNs,
      upcs: upcOrUPCs,
      urls: urlOrURLs
    }

    //
    //  If our mapping is > than 2 kB we need to POST.
    const method = JSON.stringify(mapping).length > 2000 ? 'POST' : 'GET'
    let result = null
    if (method === 'GET') {
      //
      //  Join all our arguments together, but only if required.
      const argsToJoin = ['services', 'skus', 'mpns', 'eans', 'upcs', 'urls']
      argsToJoin.map(argToJoin => {
        //
        //  If the target is an array.
        if (Array.isArray(mapping[argToJoin])) {
          mapping[argToJoin] = mapping[argToJoin].join(',')
        }
      })
      //
      //  Now build our URL.
      const url =
        baseUrl +
        `?distributor=${encodeURIComponent(mapping.distributor)}` +
        `&services=${encodeURIComponent(mapping.services)}` +
        `&language=${encodeURIComponent(mapping.language)}` +
        `&skus=${encodeURIComponent(mapping.skus)}` +
        `&eans=${encodeURIComponent(mapping.eans)}` +
        `&mpns=${encodeURIComponent(mapping.mpns)}` +
        `&upcs=${encodeURIComponent(mapping.upcs)}` +
        `&urls=${encodeURIComponent(mapping.urls)}`

      //
      //  Ok, request our matches.
      result = await loadJSON(url)
    }
    if (method === 'POST') {
      //
      //  Posting the data is just a one step process.
      result = await postJSON(baseUrl, mapping)
    }

    //
    //  All done, return the config to the caller.
    return result
  }
}
